import { api } from "@/lib/api";

// Starts a background prospect sync and polls until it finishes.
export async function runProspectSync(body, onProgress) {
  const { data } = await api.post("/admin/zones/sync-prospects", body);
  for (;;) {
    await new Promise((r) => setTimeout(r, 2000));
    const { data: job } = await api.get(`/admin/zones/sync-prospects/${data.job_id}`);
    if (onProgress) onProgress(job);
    if (job.status === "done") return job;
    if (job.status === "error") throw new Error(job.error || "Sync failed");
  }
}

export function syncReportText(job) {
  const r = job.report || {};
  const parts = [`${r.found || 0} found`, `${r.new || 0} new`, `${r.updated || 0} updated`];
  if (r.moved) parts.push(`${r.moved} moved to the right zone`);
  parts.push(`${r.requests || 0} Google requests`);
  if (r.failed) parts.push(`${r.failed} failed searches`);
  return parts.join(" · ");
}
